/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Masonry from 'react-masonry-css';
import { useSearchParams } from 'react-router-dom';
import Backdrop from '../components/Backdrop';
import EventCard from '../components/EventCard';
import Loader from '../components/Loader';
import MainLayaut from '../components/MainLayaut';
import SpectacleBackdrop from '../components/SpectacleBackdrop';
import { useGetData } from '../hooks/useGetData';

function Agenda() {
  const background = 'images/fonds/Agenda.webp';
  const { data: events, isLoading } = useGetData({ column: 'agenda' });
  console.log(events);
  const { data: spectacles } = useGetData({ column: 'spectacles' });
  const [spectacleOpen, setSpectacleOpen] = useState(false);
  const [spectacleSelected, setSpectacleSelected] = useState(null);
  const [t] = useTranslation('pages');
  const [searchParams, setSearchParams] = useSearchParams({
    id: '',
    open: false,
    title: '',
    view: 'description',
  });
  const breakpointColumnsObj = {
    default: 2, // 2 columnas en medianas
    700: 1, // 1 columna en móviles
  };
  const handleBackdrop = () => {
    // this function is empty to cancel the backdrop's behaviour and only closed it with the url manipulation
  };

  useEffect(() => {
    const id = searchParams.get('id');
    const isOpen = searchParams.get('open') === 'true';
    if (id && spectacles) {
      const spectacleToShow = spectacles.find(
        (spectacle) => `${spectacle.id}` === id
      );
      setSpectacleSelected(spectacleToShow);
    }
    setSpectacleOpen(isOpen);
  }, [searchParams, spectacles]);

  const handleOpenSpectacle = (event) => {
    setSearchParams({
      id: event.id_spectacle,
      event: event.title,
      open: true,
      view: 'description',
    });
  };
  return (
    <MainLayaut
      background={background}
      meta={{
        title: 'Acquaforte Agenda',
        description:
          'Découvrez les prochains spectacles passionnants programmés par notre compagnie. Trouvez votre prochaine expérience culturelle ici.',
      }}
    >
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className="events_grid"
        columnClassName="events_grid_column"
      >
        {isLoading ? (
          <Loader />
        ) : events?.length > 0 ? (
          events.map((event, index) => (
            <EventCard
              event={event}
              key={event.id}
              delay={index}
              onClick={() => {
                handleOpenSpectacle(event);
              }}
            />
          ))
        ) : (
          <p className="no_events_message">{t('/Agenda.no-events-message')}</p>
        )}
        {spectacleOpen && spectacleSelected && (
          <Backdrop onClick={handleBackdrop}>
            <SpectacleBackdrop
              spectacle={spectacleSelected}
              handleBackdrop={handleBackdrop}
            />
          </Backdrop>
        )}
      </Masonry>
    </MainLayaut>
  );
}

export default Agenda;
